import React from "react";
import PropTypes from "prop-types";

const ValidationSummary = props => (
  <React.Fragment>
    <span>Please correct the following and try again.</span>
    <ul className="fable:mb-0 fable:ml-16">
      {props.errors.map(error => (
        <li key={error}>{error}</li>
      ))}
    </ul>
  </React.Fragment>
);

ValidationSummary.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};

export default ValidationSummary;
